import React from 'react';

import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@uplift/ui-v2';

import {
  StepContainer, StepContent, StepContentBox, StepHeading, StepNavigator, StepNextButton, WaveBg
} from './';

export type PlanInfoConfigurableStepProps = {
  onBack?: () => void;
  onNext?: () => void;
  headerTitle?: string;
  headerHighlight?: string;
  contentTitle?: string;
  contentDescription?: string;
  nextButtonText?: string;
  showContactInfo?: boolean;
  secondaryButtonText?: string;
  onSecondaryClick?: () => void;
};

export const PlanInfoConfigurableStep: React.VFC<PlanInfoConfigurableStepProps> = ({
  onBack,
  onNext,
  headerTitle,
  headerHighlight,
  contentTitle,
  contentDescription,
  nextButtonText = 'Next',
  showContactInfo = false,
  secondaryButtonText,
  onSecondaryClick,
}) => {
  const { classes } = usePlanInfoConfigurableStepStyles();

  return (
    <StepContainer className={classes.container}>
      <StepHeading className={classes.header}>
        {headerTitle}&nbsp;
        <Typography component="span" variant="inherit" className={classes.secondaryMain}>
          {headerHighlight}
        </Typography>
      </StepHeading>
      <WaveBg color="no-background" />
      <StepContent className={classes.contentContainer}>
        <StepContentBox title={contentTitle} description={contentDescription} />
        {showContactInfo && (
          <Typography variant="body1">
            Questions about coverage limits? Contact us at{' '}
            <Typography component="span" className={classes.underline}>
              help@joinuplift.co
            </Typography>
          </Typography>
        )}
      </StepContent>
      <StepNavigator onBack={onBack}>
        <StepNextButton onClick={onNext}>{nextButtonText}</StepNextButton>
        {secondaryButtonText && (
          <Button color="secondary" onClick={onSecondaryClick}>{secondaryButtonText}</Button>
        )}
      </StepNavigator>
    </StepContainer>
  );
};

const usePlanInfoConfigurableStepStyles = makeStyles({ name: 'PlanInfoConfigurableStep' })((theme) => ({
  container: {
    background: theme.palette.beige.main,
    [theme.breakpoints.up('md')]: {
      background: 'unset',
    },
  },
  contentContainer: {
    paddingTop: theme.spacing(1),
  },
  secondaryMain: {
    color: theme.palette.secondary.main,
  },
  header: {
    fontSize: '34px',
    paddingTop: theme.spacing(7),
    margin: theme.spacing(0, 2, 3, 2),
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      width: '100%',
      maxWidth: `calc(640px + ${theme.spacing(1)})`,
      margin: '0 auto',
      paddingBottom: theme.spacing(3),
    },
  },
  underline: {
    textDecoration: 'underline',
  },
}));
